import { ENV } from '@/shared/lib/env';
import { socketInstance } from '../socket.instance';

type ListenEvents = {
  'sync-progress-updated': (data: { progress: number; title: string }) => void;
  'sync-failed': (data: { title: string }) => void;
};
type EmitEvents = {};

export const globalSocket = socketInstance<ListenEvents, EmitEvents>(
  ENV.backendApiUrl
);
